import styled from '@emotion/styled';
import { Magnetic } from "../../styles";
export const ZoomComponent = styled('div') `
	height: 100%;
	position: relative;
`;
export const ChildContainer = styled('div') `
	user-select: none;
	overflow: hidden;
	margin: auto;
	height: 100%;
	width: ${(props) => (props.centerContent ? '78%' : 'auto')};
`;
export const ChildComponent = styled('div') `
	height: 100%;
`;
export const ZoomContainer = styled('div') `
	user-select: none;
	transform: translateY(-50%);
	position: absolute;
	top: ${Magnetic.spacer48};
	right: ${Magnetic.spacer04};
`;
// These functions are extracted to allow for direct testing for coverage
export const getZoomButtonColor = (props) => props.disabled ? Magnetic.disabledFontColor : Magnetic.actionableColor;
export const getZoomButtonHoverColor = (props) => props.disabled ? Magnetic.disabledFontColor : Magnetic.actionableColorHover;
export const getZoomButtonActiveColor = (props) => props.disabled ? Magnetic.disabledFontColor : Magnetic.actionableColorActive;
export const getZoomButtonCursorStyle = (props) => props.disabled ? Magnetic.disabledCursor : Magnetic.actionableCursor;
export const ZoomButton = styled('span') `
	display: block;
	padding: ${Magnetic.spacer08};
	font-size: ${Magnetic.fontSize22};
	color: ${getZoomButtonColor};
	&:hover {
		color: ${getZoomButtonHoverColor};
	}
	&:active {
		color: ${getZoomButtonActiveColor};
	}
	cursor: ${getZoomButtonCursorStyle};
`;
//# sourceMappingURL=style.js.map